// removed by extract-text-webpack-plugin
module.exports = {"vpPromptLabelContainer":"vpPromptLabelContainer___1SYOH","vpPromptBadgeLabel":"vpPromptBadgeLabel___3ODtv","vpPromptBadgeContainer":"vpPromptBadgeContainer___16ESF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignEdit/PromptLabelContainer.module.less
// module id = 3264
// module chunks = 31